/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:01:30
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/sticky.js
 */
export default {
    // sticky组件
    sticky: {
        offsetTop: 0,
        customNavHeight: 0,
        disabled: false,
        bgColor: 'transparent',
        zIndex: '',
        index: ''
    }
}
